import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ReferEarn from "@/pages/ReferEarn";
import Admin from "@/pages/Admin";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyOtp from "@/pages/VerifyOtp";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Payment from "@/pages/Payment";
import Success from "@/pages/Success";
import { isAuthenticated } from "@/lib/auth";

function Protected({ children }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment" element={<Protected><Payment /></Protected>} />
          <Route path="/success" element={<Protected><Success /></Protected>} />
          <Route path="/refer-earn" element={<Protected><ReferEarn /></Protected>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
